module.exports = __webpack_public_path__ + "static/seller/img/null02.48de6aa0.jpg";